import { SurveyBackground } from "../components/surveyComponents/SurveyBackground";
import pantalla404 from "../img/Pantalla-404.png";

export default function NotFoundPage() {
    return <SurveyBackground background={pantalla404}></SurveyBackground>;
}
